import React, { useMemo, useState } from 'react';

const IssuesOverview = ({ data }) => {
    const [showAllIssues, setShowAllIssues] = useState(false);

    const issuesData = useMemo(() => data.flatMap(vehicle =>
        vehicle.complaints.map(complaint => ({
            vehicle_name: vehicle.vehicle_name || 'N/A',
            product_version: vehicle.product_version || 'N/A',
            issue_description: complaint.customer_complaint_description || 'N/A',
            severity: complaint.severity || 'N/A',
        }))
    ), [data]);

    const limitedIssuesData = useMemo(() => showAllIssues ? issuesData : issuesData.slice(0, 5), [showAllIssues, issuesData]);

    return (
        <div className="overview-section">
            <h3>Issues Overview</h3>
            <div className="table-container">
                <table className="overview-table">
                    <thead>
                        <tr>
                            <th>Vehicle Name</th>
                            <th>Product Version</th>
                            <th>Issue Description</th>
                            <th>Severity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {limitedIssuesData.map((issue, index) => (
                            <tr key={index}>
                                <td>{issue.vehicle_name}</td>
                                <td>{issue.product_version}</td>
                                <td>{issue.issue_description}</td>
                                <td>{issue.severity}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button onClick={() => setShowAllIssues(!showAllIssues)} className="toggle-button">
                {showAllIssues ? 'Show Less' : 'Show More'}
            </button>
        </div>
    );
};

export default IssuesOverview;
